<template lang='pug'>
.records-root.container
  template(v-if='$route.path === "/records"')
    h1 信息记录
    br
    router-link.ui.button.themed(to='/records/meters') 公寓水电表记录
  template(v-else)
    h1: router-link(to='/records') < 返回
  router-view
</template>

<script>
export default {
  name: 'records-root',
}
</script>



// WEBPACK FOOTER //
// Records.vue?77dfc2d2